export enum ReferenceLookupNoMatchOption {
  Continue = 0,
  ClearReferences = 1
}